import Vue from 'vue';
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import VueCryptojs from 'vue-cryptojs';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';

Vue.component('l-map', LMap);
Vue.component('l-tile-layer', LTileLayer);
Vue.component('l-marker', LMarker);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  VueCryptojs,
  render: (h) => h(App),
}).$mount('#app');

// const encryptedText = this.CryptoJS.AES
//  .encrypt("Hi There!", "Secret Passphrase").toString();
// const decryptedText = this.CryptoJS.AES
//  .decrypt(encryptedText, "Secret Passphrase").toString(this.CryptoJS.enc.Utf8);
